<template>
  <b-row>
    <b-col lg="12" md="12" sm="12" class="mt-1">
      <h5>Operador {{ operador.departamento.sigla }}</h5>
    </b-col>

    <!-- Dose + Gesto Vacinal: -->
    <b-col lg="6" md="6" sm="12">
      <b-form-group>
        <label :for="targerForIDFocusDoseGestaoGrupo"
          >Dose + Gesto Vacinal</label
        >
        <b-input-group>
          <b-input-group-prepend>
            <div class="bg-custom-blue d-flex align-items-center custom-append-input rounded adjustIconInputValue">
              <b-img :src="Ricon" alt="Icone que representa o real" />
            </div>
          </b-input-group-prepend>

          <b-form-input
            class="adjustInput"
            v-model="doseGestoVacinal"
            v-money-nullable="moneyMask"
            :id="targerForIDFocusDoseGestaoGrupo"
            placeholder="00,00"
            @keypress="onlyNumber"
          />
        </b-input-group>
      </b-form-group>
    </b-col>

    <!-- Taxa de Gestão: -->
    <b-col lg="6" md="6" sm="12">
      <b-form-group>
        <label :for="targerForIDFocusDoseTaxaGrupo">Taxa de Gestão:</label>
        <b-input-group>
          <b-input-group-prepend>
            <div class="bg-custom-blue d-flex align-items-center custom-append-input rounded adjustIconInputValue">
              <b-img :src="Ricon" alt="Icone que representa o real" />
            </div>
          </b-input-group-prepend>
          <b-form-input
            class="adjustInput"
            v-model="taxaDeGestao"
            v-money-nullable="moneyMask"
            :id="targerForIDFocusDoseTaxaGrupo"
            placeholder="00,00"
            @keypress="onlyNumber"
          />
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCol,
  BCollapse,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BForm,
} from "bootstrap-vue";
import Ricon from "@/assets/images/icons/RIcon.svg";
import helpers from "@/helpers";
import {
  CampanhaNacionalGetPrecificacaoDoseGestoTaxaVacinaGrupoEmpresaOperador,
  CampanhaNacionalSetPrecificacaoDoseGestoTaxaVacinaGrupoOperadorValores,
} from "@/views/custom-pages/campanha-nacional/Helpers/campanhaNacionalHelpers.js";

export default {
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCol,
    BCollapse,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BImg,
    BInputGroup,
    BInputGroupPrepend,
    BRow,
    BForm,
  },
  props: {
    moneyMask: {
      type: Object,
      required: true,
    },
    vacina: {
      type: Object,
      required: true,
    },
    grupo: {
      type: Object,
      required: true,
    },
    operador: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Ricon,
      targerForIDFocusDoseTaxaGrupo: helpers.geraNumeroAleatorio().toString(),
      targerForIDFocusDoseGestaoGrupo: helpers.geraNumeroAleatorio().toString(),
    };
  },
  methods: {
    getValores() {
      return CampanhaNacionalGetPrecificacaoDoseGestoTaxaVacinaGrupoEmpresaOperador(
        this.vacina.id_vacina,
        this.grupo.id_grupo,
        this.operador.id_departamento
      );
    },
    setValores(campoAlteracao, valor) {
      CampanhaNacionalSetPrecificacaoDoseGestoTaxaVacinaGrupoOperadorValores(
        this.vacina.id_vacina,
        this.grupo.id_grupo,
        this.operador.id_departamento,
        campoAlteracao,
        valor
      );
    },
    onlyNumber(event) {
      if (!helpers.keyIsNumber(event)) {
        event.preventDefault();
      }
    },
  },
  computed: {
    doseGestoVacinal: {
      get() {
        return this.getValores().dose_gesto_vacinal;
      },
      set(valor) {
        this.setValores("dose_gesto_vacinal", valor);
      },
    },
    taxaDeGestao: {
      get() {
        return this.getValores().taxa_de_gestao;
      },
      set(valor) {
        this.setValores("taxa_de_gestao", valor);
      },
    },
  },
};
</script>
